import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Zap, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account created");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="register-form">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 grid place-items-center rounded-md bg-primary text-primary-foreground"><Zap className="w-4 h-4" /></div>
          <span className="font-display text-lg font-semibold">DIGI-JIRA</span>
        </div>
        <div>
          <h2 className="font-display text-2xl font-semibold tracking-tight">Create your account</h2>
          <p className="text-sm text-muted-foreground mt-1">Get started in 30 seconds.</p>
        </div>
        <div className="space-y-4">
          <div className="space-y-1.5"><Label>Full name</Label><Input value={form.name} onChange={update("name")} required data-testid="reg-name" /></div>
          <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={form.email} onChange={update("email")} required data-testid="reg-email" /></div>
          <div className="space-y-1.5"><Label>Password</Label><Input type="password" value={form.password} onChange={update("password")} required minLength={6} data-testid="reg-password" /></div>
        </div>
        <Button type="submit" disabled={loading} className="w-full" data-testid="reg-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create account"}
        </Button>
        <div className="text-sm text-muted-foreground text-center">
          Already have an account? <Link to="/login" className="text-primary hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
